



























































































































































































































import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { PageTitle } from '../../core/components';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Input from '../../core/components/Input.vue';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import { activeFormatter, ColorsList, convertDictionaryToList, convertListToArrOfObjects, EventBus, formatDate, getDateAsMoment, getDateFormattedAsMoment, getDateTimeFromToDay, getDateTimeFromYesterday, getDateTimeToToDay, getDateTimeToYesterday, isNullOrEmpty, openTravelWithParameter, substractTimeToDate, TypeEventBus } from '../../core/utils';
import { AuthStoreHelper, CompanyStoreHelper, NotificationStoreHelper, VehicleCompanyStoreHelper } from '../../core/mixins';
import { ReempujonServices } from '../api/ReempujonServices';
import ReempujonList from '../components/ReempujonList.vue';
import { DtcAck, ReempujonPanelItem } from '../models/Reempujon';
import { ActivesOptions, SeenOptions } from '../../insurance/options';
import Combobox from '../../core/components/Combobox.vue';
import { dateTypes, diffOptions } from '../../core/models/date-models';
import { SettingsService } from '../../settings/api/SettingsService';
import { TableFilters, TableFiltersParams } from '../models/panel'
import { sortTypes } from '../../core/models/Table';
import Axios, { CancelTokenSource } from 'axios';
import CreateDTC from '../../norms/components/CreateDTC.vue';
import { NormsServices } from '../../norms/api/NormsServices';
import InfoIcon from '../../core/components/InfoIcon.vue';
import MultipleSelect from '../../core/components/MultipleSelect.vue';
import RefreshButton from '../../core/components/RefreshButton.vue';
import { TypeFilterDate } from '../../core/models';
@Component({
   components: {
       PageTitle,
       SimpleTable,
       Input,
       Combobox,
       InfoIcon,
       CreateDTC,
       MultipleSelect,
       RefreshButton
   }
})
export default class ReempujonManagementPanel extends Mixins(
   NotificationStoreHelper,
   AuthStoreHelper,
   CompanyStoreHelper,
   VehicleCompanyStoreHelper
) {
   goldColor: string = ColorsList.gold;
   dtcInfo: ReempujonPanelItem | null = null;
   sortBy: string[] = ['dtcname'];
   sortDesc: boolean[] = [false];
   loadingDelete: boolean = false;
   dtcsList: Array<ReempujonPanelItem> = [];
   private onCloseDatepickerPopup: Function | null = null;

   search: string = '';
   deleteTitle: string = '';
   imageUrl: string = require('../logo_reempujon.png');
   propertiesData: object = {};
   headers: Array<object> = [
       {
           text: 'Vehículo',
           align: 'left',
           value: 'vehicle_description',
       },
       {
           text: 'Empresa',
           align: 'left',
           value: 'companies',
           formatter: (value) => {
               return value.join(', ');
           },
       },
       {
           text: 'Módulo',
           align: 'left',
           value: 'module',
       },
       {
           text: 'Código de falla',
           align: 'left',
           value: 'dtc',
       },
       {
           text: 'Descripción',
           align: 'left',
           value: 'description',
       },
       {
           text: 'Estado',
           align: 'center',
           value: 'status',
           formatter: (value) => {
               return this.formatState(value)
           },
       },
       {
           text: 'Clasificación',
           align: 'center',
           value: 'classification',
           formatter: (value) => {
               return this.formatClassifications(value);
           },
       },
       {
           text: 'Vista',
           align: 'left',
           value: 'ack',
       },
       {
           text: 'Fecha falla',
           align: 'center',
           value: 'timestamp',
           width: '220px',
           formatter: (value) => {
               return formatDate(value, true);
           },
       },
       {
           text: 'Acciones',
           align: 'center',
           value: 'actions',
           sortable: false,
       },
   ];
   pendingItems: boolean = false;
   visibleEditDTC: boolean = false;
   dtcIdToDelete: number = -1;
   hasToLogoutdtc: boolean = false;
   failsCodeOptions: Array<object> = [];
   moduleOptions: Array<object> = [];
   activesAndInactivesOptions: Array<object> = ActivesOptions;
   seenOptions: Array<object> = SeenOptions;
   classificationOptions: Array<object> = [];
   
   moduleSelected: object | null = null;
   activesAndInactivesSelected: object | null = null;
   classificationSelected: object | null = null;
   companySelected: object | null = null;
   seenSelected: object | null = null;

   moduleSelectedRv: boolean = false;
   activesAndInactivesSelectedRv: boolean = false;
   classificationSelectedRv: boolean = false;
   pendingVehicles: boolean = false;
   seenSelectedRv: boolean = false;
   companySelectedRv: boolean = false;
   vehicleSelected: object | null = null;
   vehicleSelectedRv: boolean = false;
   vehiclesList: Array<object> = [];
   searchParams: TableFiltersParams = {
       page: 1,
       page_size: 10,
   };
   
   filtersParams: TableFilters = {};
   searchRanchList: string = '';
   savedQueries: string[] = [];
   requestTokenInstance: CancelTokenSource = Axios.CancelToken.source();
   paginationTotalPages: number = 0;
   paginationTotalRows: number = 0;
   brandOptions: Array<object> = [];
   protocolTypes: Array<object> = [];
   dtcToPatch: object = {};
   classificationTypes: Array<object> = [];
   filtersVehiclesSelected: Array<object> = [];

   filtersSelectInsuranceCompany(itemToAdd) {
       this.filtersVehiclesSelected.push(itemToAdd);
   }

   filtersRemoveInsuranceCompany(itemToRemove) {
       this.filtersVehiclesSelected = this.filtersVehiclesSelected.filter(
           item => item['id'] !== itemToRemove.id
       );
   }

   updateDtcAck(ackInfo, dtcId){
       let dtc = this.dtcsList.findIndex((item) => {
           return item.id == dtcId;
       });
       if(dtc != -1){
           this.$set(this.dtcsList[dtc], 'ack', ackInfo.ack);
           this.$set(this.dtcsList[dtc], 'ack_timestamp', ackInfo.ack_timestamp);
           this.$set(this.dtcsList[dtc], 'ack_username', ackInfo.ack_username);
       }
   }

   getAckTooltip(item: ReempujonPanelItem){

       return `
           Vista: ${formatDate(item.ack_timestamp, true)}<br>
           Usuario: ${item.ack_username}
       `
   }

   markAsAck(item: ReempujonPanelItem){
       let params: DtcAck = {
           ack: item.ack,
           id: item.id
       }

        ReempujonServices.markDtcAck(
           params
       ).then(response => {
           this.$_showAddPointOfInterest(response.message);

           this.$set(item, 'ack_timestamp', response.ack.ack_timestamp);
           this.$set(item, 'ack_username', response.ack.ack_username);
           this.$set(item, 'ack', response.ack.ack);
           
       }).catch(error => {
           this.$_catchLoadingDialog({
               response: error.response.data || {},
               alternative_msg: 'No se pudo marcar como visto'
           });
       }).finally(() => {
       });
   }

   editDtc(item: ReempujonPanelItem){
       this.assignVariables();
       this.dtcToPatch = {
           ...item,
           classification: this.getDescriptionAndIdForClassification(item.classification),
           protocol: this.getDescriptionForProtocol(item.protocol),
           commentary: this.getCommentaryForDtc(item),
           status: this.propertiesData['state'][item.status],
       };
       this.visibleModalEditDtc(true);
   }

   getCommentaryForDtc(item: ReempujonPanelItem){
       let hasCommentary = !isNullOrEmpty(item.commentary);
       if(hasCommentary){
           return {
               text: item.commentary,
               timestamp: item.commentary_timestamp,
               user: {
                   id: item.commentary_user_id,
                   username: item.commentary_username,
               }
           }
       }

       return null;
       
   }

   getDescriptionAndIdForClassification(classification_id: number){
       let classification = this.propertiesData['classification'];
       let classificationDescription = classification[classification_id] ? classification[classification_id] : '';
       return {
           id: classification_id,
           description: classificationDescription
       }
   }

   getDescriptionForProtocol(protocol_id: number){
       let protocols = this.$_getNormsProperties['all_protocols'];
       let protocolDescription = protocols[protocol_id] ? protocols[protocol_id] : '';
       return protocolDescription
   }

   updateDTC(data){
       let dtc = this.dtcsList.findIndex((item) => {
           return item.dtc_id == data.id;
       });
       if(dtc != -1){
           this.$set(this.dtcsList[dtc], 'description', data.description);
           this.$set(this.dtcsList[dtc], 'classification', data.classification['id']);
           this.$set(this.dtcsList[dtc], 'commentary', data.commentary['text']);
           this.$set(this.dtcsList[dtc], 'commentary_timestamp', data.commentary['timestamp']);
           this.$set(this.dtcsList[dtc], 'commentary_user_id', data.commentary['user']['id']);
           this.$set(this.dtcsList[dtc], 'commentary_username', data.commentary['user']['username']);
       }
       this.visibleModalEditDtc(false);
       
   }

   get getCompanies(){
       return this.$_getCompanies
   }


   updateTableOptions({sortBy, sortDesc, itemsPerPage, page}){
       this.searchParams.page_size = itemsPerPage;
       this.searchParams.page = page;
       if(sortBy.length ==  0){
           delete this.searchParams.sort_by;
           delete this.searchParams.sort_type;
       }else{
           let sortType = sortDesc[0] == true ? sortTypes.desc : sortTypes.asc;
           this.searchParams.sort_by = sortBy;
           this.searchParams.sort_type = sortType;
       }
       // console.log("updateTableOptions", {
       //     sortBy: sortBy,
       //     sortDesc: sortDesc,
       // })
       this.findDtcs();
       
   }

   updatesearchParams(page, itemsPerPage){
       this.searchParams.page = page;
       this.searchParams.page_size = itemsPerPage;
       this.searchParams.query = this.search;
       this.findDtcs();
   }

   findDtcs(){
       this.getdtcs();
   }


   updateVehicleSelected(value){
       this.vehicleSelected = value;
   }

   updateVehicleSelectedRV(value){
       this.vehicleSelectedRv = value;
   }

   updateCompanySelected(company){
       this.filtersVehiclesSelected = [];
       this.updateVehiclesList(company)
       this.companySelected = company;
   }

   updateVehiclesList(company: number){
       if(company == null){
           this.vehiclesList = [];
           return;
       }

       this.pendingVehicles = true;
       SettingsService.getVehiclesList(
           company['id'], 
           false
       ).then((res) => {
           this.pendingVehicles = false;
           this.vehiclesList = res;
       }).catch((e) => {
           this.pendingVehicles = false;
           this.$_catchLoadingDialog({
               response: e.response.data || {},
               alternative_msg: 'Falló la obtención de vehículos'
           });
       })
   }

   updateCompanySelectedRV(value){
       this.companySelectedRv = value;
   }

   updateModuleSelected(value){
       this.moduleSelected = value;
   }
   updateModuleSelectedRV(value){
       this.moduleSelectedRv = value;
   }
   updateClassificationSelected(value){
       this.classificationSelected = value;
   }
   updateClassificationSelectedRV(value){
       this.classificationSelectedRv = value;
   }
   updateActivesAndInactivesSelected(value){
       this.activesAndInactivesSelected = value;
   }
   updateActivesAndInactivesSelectedRV(value){
       this.activesAndInactivesSelectedRv = value;
   }
   updateSeenSelected(value){
       this.seenSelected = value;
   }
   updateSeenSelectedRV(value){
       this.seenSelectedRv = value;
   }


   assignVariables() {
       this.protocolTypes = convertDictionaryToList(this.getDataFromNormsProperties('all_protocols'));
       this.classificationTypes = this.getDataFromNormsProperties('all_dtc_classifications');
       this.brandOptions = convertDictionaryToList(this.getDataFromNormsProperties('all_brands'));
   }

    getDataFromNormsProperties(option) {
       return this.$_getNormsProperties[option];
   }

   get rangeDateIsEmpty(){
       if(this.$_getFilterDate === TypeFilterDate.RANGE_DATE){
           return isNullOrEmpty(this.$_getDateRange.datetime_from) || isNullOrEmpty(this.$_getDateRange.datetime_to);
       }
       return false;
   }

   @Watch('$_getFilterDate')
   onFilterDateChanged(value){
       if(!this.rangeDateIsEmpty){
           this.searchParams.page = 1;
           this.findDtcs();
       }
       
   }

   @Watch('search')
   @Watch('moduleSelected')
   @Watch('classificationSelected')
   @Watch('activesAndInactivesSelected')
   @Watch('seenSelected')
   @Watch('companySelected')
   @Watch('filtersVehiclesSelected')
   onFiltersChanged(){
       let params: TableFiltersParams = {
           page: 1,
           page_size: this.searchParams.page_size,
       };
       if(!isNullOrEmpty(this.search)){
           params['query'] = this.search;
       }
       if(this.moduleSelected != null){
           params['module'] = this.moduleSelected['id'];
       }
       if(this.classificationSelected != null){
           params['classification'] = this.classificationSelected['id'];
       }
       if(this.activesAndInactivesSelected != null){
           params['status'] = this.activesAndInactivesSelected['id'];
       }
       if(this.seenSelected != null){
           params['ack'] = this.seenSelected['value'];
       }
       if(this.companySelected != null){
           params['company_id'] = this.companySelected['id'];
       }
       if(this.filtersVehiclesSelected.length > 0){
           params['vehicle_ids'] = this.filtersVehiclesSelected.map((item) => {
               return item['id'];
           }).join(',');
       }

       this.searchWhenFiltersChange(params)
   }

   searchWhenFiltersChange(params: TableFiltersParams){
       this.searchParams.page = 1;
       this.searchParams = {
           ...params,
       };
       this.findDtcs();
   }

   @Watch('savedQueries', { immediate: true, deep: true })
   watchSavedQueries(value){
       this.searchParams.query = value.join(',');
       this.findDtcs();
   }

    updateSavedFilters(value){
       this.savedQueries = value;
   }
   
   
   

   updateSearchValue(value){
       this.search = value;
       if(isNullOrEmpty(value)){
           delete this.searchParams.query;
       }else{
           this.searchParams.query = value;
       }
       this.searchParams.page = 1
       this.findDtcs();
   }

   created(){
       this.getPropertiesInfo();
   }

   formatClassifications(value){
       let classification = this.propertiesData['classification'];
       return classification[value];
   }

   formatState(value){
      let states = this.propertiesData['state'];
        return states[value];
   }

   assignOptionsForComboboxes(){
       let modules = this.propertiesData['modules'];
       let classification = this.propertiesData['classification'];
       this.classificationOptions = convertDictionaryToList(classification);
   }

   getPropertiesInfo(){
       this.pendingItems = true;
       ReempujonServices.getProperties()
       .then((res) => {
           this.propertiesData = res;
           this.assignOptionsForComboboxes();
           this.getdtcs();
       }).catch((e) => {
           this.$_catchLoadingDialog({
               response: e.response.data || {},
               alternative_msg: 'Falló la obtención de propiedades'
           });
       })
   }

   getQueryParamsWithDateFilters(params: TableFiltersParams):TableFiltersParams{
       let filtersValues = {
           [TypeFilterDate.RANGE_DATE]: {
               datetime_from: this.$_getDateRange.datetime_from,
               datetime_to: this.$_getDateRange.datetime_to,
           },
           [TypeFilterDate.TODAY]: {
               datetime_from: getDateTimeFromToDay(),
               datetime_to: getDateTimeToToDay(),
           },
           [TypeFilterDate.YESTERDAY]: {
               datetime_from: getDateTimeFromYesterday(),
               datetime_to: getDateTimeToYesterday(),
           },
           //por el momento "ahora" usa el filtro de hoy
           [TypeFilterDate.TR]: {
               datetime_from: getDateTimeFromToDay(),
               datetime_to: getDateTimeToToDay(),
           }
       }

       let currentFilters = filtersValues[this.$_getFilterDate]

       if(this.rangeDateIsEmpty){
           delete params.datetime_from;
           delete params.datetime_to;
           return params;
       }

       params.datetime_from = currentFilters.datetime_from;
       params.datetime_to = currentFilters.datetime_to;

       return params
   }

   getdtcs(){
           this.requestTokenInstance.cancel();
           this.requestTokenInstance = Axios.CancelToken.source();
           this.pendingItems = true;
           let queryParams = this.getQueryParamsWithDateFilters(this.searchParams);
           ReempujonServices.getManagementPanelItems(
               this.requestTokenInstance, 
               queryParams
           )
           .then(res => {
               this.paginationTotalPages = res.totalPages;
               this.paginationTotalRows = res.count;
               this.moduleOptions = res.modules;
               this.dtcsList = res.data;
               this.pendingItems = false;
           })
           .catch(err => {
               if(err && err.message == 'Request canceled'){
                   this.pendingItems = true;
                   return;
               }
               this.paginationTotalPages = 1;
               this.paginationTotalRows = 0;
               this.dtcsList = [];
               this.pendingItems = false;
               if(err && err.response && err.response.data){
                   this.$_catchLoadingDialog({
                       response: err.response.data || {},
                       alternative_msg: 'Falló el listado de dtcs'
                   });
               }
           })
   }


   clickViewInMap(vehicle: ReempujonPanelItem){
       let datetime_from: string = vehicle.timestamp;
       let vehicleCompanies:number = vehicle.companies.length;
       if(vehicleCompanies == 0){
           this.$_showHistoricalError('El vehículo no tiene empresas asociadas');
           return;
       }
       //la fecha datetime_from es la fecha timestamp - 30 minutos
       datetime_from = getDateFormattedAsMoment(substractTimeToDate(getDateAsMoment(datetime_from, dateTypes.globalFilterDateFormat), 30, diffOptions.minutes), dateTypes.globalFilterDateFormat);

       let datetime_to: string = vehicle.timestamp;
       //le agrego un margen de 15 minutos a la fecha datetime_to
       datetime_to = getDateFormattedAsMoment(substractTimeToDate(getDateAsMoment(datetime_to, dateTypes.globalFilterDateFormat), -15, diffOptions.minutes), dateTypes.globalFilterDateFormat);
       let params = {
           datetime_from: datetime_from,
           datetime_to: datetime_to,
           vehicles: [vehicle.vehicle_id],
           companyId: vehicle.travel_id,
           newTab: true
       }
       openTravelWithParameter(
           params.datetime_from,
           params.datetime_to,
           params.vehicles,
           params.companyId,
           params.newTab
       );
   }

   mounted() {
       this.onCloseDatepickerPopup = () => {
           if (!this.rangeDateIsEmpty) {
               this.searchParams.page = 1;
               this.findDtcs();
           }
       };

       EventBus.$on(TypeEventBus.CLOSE_DATEPICKER_POPUP, this.onCloseDatepickerPopup);

       this.$nextTick(() => {
           this.assignVariables();
       });
   }

   closeModalDtc(){
       this.visibleModalEditDtc(false);
   }

   closedtcPreferences(){
       this.dtcInfo = null;
       this.visibleModalEditDtc(false)
   }

   visibleModalEditDtc(value){
       this.visibleEditDTC = value;
   }
   
   volverAConfiguracion() {
       this.$router.push(NAME_ROUTES.SETTINGS.path);
   }

   beforeDestroy() {
       if (this.onCloseDatepickerPopup) {
           EventBus.$off(TypeEventBus.CLOSE_DATEPICKER_POPUP, this.onCloseDatepickerPopup);
       }
   }
}
